import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as Logout } from '../../assets/icons/log-out.svg';
import DashBoard from '../../components/DashBoard/DashBoard';
import SubHeader from '../../components/SubHeader/SubHeader';
import Paragraph from '../../components/Typography/Paragraph/Paragraph';
import UploadPhoto from '../../components/UploadPhoto/UploadPhoto';
import { walletItems } from '../../components/WalletBox/WalletBoxIcons';
import useResponsive from '../../hooks/useResponsive';
import { useAppDispatch } from '../../store/reducers';
import { logout } from '../../store/reducers/Auth/authSlice';
import { clearChatData } from '../../store/reducers/Chat/slice';
import { clearNotificationData } from '../../store/reducers/Notifications/slice';
import { clearUpcomingRacesData } from '../../store/reducers/Race/raceSlice';
import { clearResultsData } from '../../store/reducers/Results/resultsSlice';
import { clearWalletData, resetWalletsBucketThunk } from '../../store/reducers/Wallet/slice';
import styles from './MyAccount.module.scss';
import Settings from './Settings/Settings';
import StableAccounts from './StableAccounts/StableAccounts';
import CookiesService from '../../services/cookies.service';
const MyAccount = () => {
    const { t } = useTranslation();
    const isResponsive = useResponsive('xl');
    const [cookies, setCookie, removeCookie] = useCookies();
    const dispatch = useAppDispatch();
    const loggedIn = useSelector((state) => state.auth.loggedIn);
    const removeCachedWalletCookies = useCallback(() => {
        CookiesService.clearAllCookies();
    }, []);
    const onLogout = useCallback(() => {
        dispatch(logout());
        dispatch(clearWalletData());
        dispatch(clearNotificationData());
        dispatch(clearChatData());
        dispatch(clearUpcomingRacesData());
        dispatch(clearResultsData());
        removeCachedWalletCookies();
        dispatch(resetWalletsBucketThunk(walletItems));
    }, [dispatch, cookies, removeCookie, removeCachedWalletCookies]);
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [!isResponsive && _jsx(SubHeader, { title: t('my_account') }), _jsx(DashBoard, { children: _jsxs("div", Object.assign({ className: styles.box }, { children: [_jsx(StableAccounts, {}), _jsx(UploadPhoto, { className: styles.photo }), _jsx(Settings, {}), loggedIn && (_jsxs("div", Object.assign({ onClick: onLogout, className: cn(styles.logout, 'd-flex align-items-center') }, { children: [_jsx(Logout, {}), _jsx(Paragraph, { color: 'gold', title: t('log_out').toLocaleUpperCase() })] })))] })) })] })));
};
export default MyAccount;
